export function isValidEmailAddress(emailCandidate) {
  // this is only checking the basic email form
  // const reg = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/; // multiple emails
  const reg =
    /^([a-zA-Z0-9_+\-.À-ž\\&]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9À-ž\-]+\.)+))([a-zA-ZÀ-ž]{2,16}|[0-9]{1,3})(\]?)$/ // one email
  return reg.test(emailCandidate)
}

export function camelize(text, separator = '-') {
  const str = text
    .split(separator)
    .map((m) => m.charAt(0).toUpperCase().concat(m.substr(1)))
    .join('')
  return str.charAt(0).toLowerCase().concat(str.substr(1))
}
